import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import { Api } from '../../typings/api';
import { ListDisplayType } from '../DriveItemList/constants';
import DriveItem from '../../components/DriveItem';
import DownloadManagerUtils from '../../utils/downloadManager';
import DriveItemUtils from '../../utils/driveItem';

interface DriveItemOwnProps {
	driveItem: Api.DriveItem;
	showUnreadBadge: boolean;
	displayType: ListDisplayType;
}

const mapStateToProps = (state: StoreState, ownProps: DriveItemOwnProps) => {
	const { offlineManager, galleryInfos, downloadManager, driveList, readStatus } = state;
	const { config: galleryConfig } = galleryInfos;
	const { contextualMenu, resolutions, isEditMode } = driveList;
	const { driveItem, showUnreadBadge, displayType } = ownProps;
	const isSelectedForContextualMenu = contextualMenu.isOpened
		? contextualMenu.driveItemId === driveItem.id
		: false;
	const isDownloading = DownloadManagerUtils.isItemDownloading(downloadManager, driveItem.id);
	const isDownloaded = DownloadManagerUtils.isItemDownloaded(downloadManager, driveItem.id);
	const isUnread = showUnreadBadge && DriveItemUtils.isUnread(driveList, readStatus, driveItem.id);
	const loaderStep = DownloadManagerUtils.getItemLoaderStep(downloadManager, driveItem.id);
	const thumbnailIsBox = displayType !== ListDisplayType.Row;
	const thumbnailDescriptor = DriveItemUtils.getThumbnailDescriptor(driveItem, thumbnailIsBox, offlineManager, galleryConfig, resolutions, displayType);

	return {
		displayType,
		isSelectedForContextualMenu,
		isDownloading,
		isDownloaded,
		loaderStep,
		thumbnailDescriptor,
		isUnread,
		isEditMode,
	};
};

export default connect(mapStateToProps)(DriveItem);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItem/index.tsx